import * as React from "react";
import { useStopwatchStateController } from "features/architecture/worksessions/controllers/useStopwatchStateController";

type StopwatchContextValue = ReturnType<typeof useStopwatchStateController>;

const StopwatchContext = React.createContext<StopwatchContextValue | undefined>(
  undefined,
);

export const StopwatchProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const value = useStopwatchStateController();

  return (
    <StopwatchContext.Provider value={value}>
      {children}
    </StopwatchContext.Provider>
  );
};

export const useStopwatch = () => {
  const ctx = React.useContext(StopwatchContext);
  if (!ctx) {
    throw new Error("useStopwatch must be used within StopwatchProvider");
  }
  return ctx;
};

